module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"container-slim\"> <div class=\"section-margin\"> <h2>CanadaPost Registration</h2> <p>Now redirecting you to the CanadaPost website to link your account...</p> <form id=\"cp_registration_form\" class=\"hidden\" action=\"")
    ; __append(escapeFn( locals.registrationURL ))
    ; __append("\" accept-charset=\"UTF-8\" method=\"post\"> <input type=\"hidden\" name=\"token-id\" id=\"token-id\" value=\"")
    ; __append(escapeFn( locals.tokenID ))
    ; __append("\"> <input type=\"hidden\" name=\"language\" id=\"language\" value=\"en\"> <input type=\"hidden\" name=\"platform-id\" id=\"platform-id\" value=\"")
    ; __append(escapeFn( locals.platformID ))
    ; __append("\"> <input type=\"hidden\" name=\"return-url\" id=\"return-url\" value=\"")
    ; __append(escapeFn( locals.returnURL ))
    ; __append("\"> </form> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/canada_post_account_registration_page.ejs
// module id = 831
// module chunks = 1